<bom-validation-summary [myForm]="form"></bom-validation-summary>

<bom-workspace
  [titleKey]="showWorkspaceTitle ? 'Kontaktoplysninger.Overskrift' : ''"
  [descriptionKey]="showWorkspaceTitle ? 'Kontaktoplysninger.Personlig' : ''"
>
  <ng-container *ngIf="currentProfilService.profilInformation$ | async; else loading">
    <div class="row profile-info-wide">
      <form [formGroup]="form" class="mb-5 col">
        <div class="form-group">
          <ng-container *ngIf="authService.isCitizen$ | async; else notCitizen">
            <label class="form-label icon-link" for="{{ FormControlNames.Navn }}">{{
              'Kontaktoplysninger.Navn' | tekstresource
            }}</label>
            <div class="row">
              <div class="col-7">
                <input
                  class="form-input"
                  formControlName="navn"
                  name="kontaktoplysninger-navn-input"
                  id="{{ FormControlNames.Navn }}"
                  type="text"
                />
              </div>
            </div>
          </ng-container>
          <ng-template #notCitizen>
            <label class="form-label icon-link" for="{{ FormControlNames.Cvr }}">{{
              'Kontaktoplysninger.Cvr' | tekstresource
            }}</label>
            <div class="row">
              <div class="col-3">
                <input
                  class="form-input"
                  formControlName="cvr"
                  name="kontaktoplysninger-navn-input"
                  id="{{ FormControlNames.Cvr }}"
                  type="text"
                />
              </div>
            </div>
          </ng-template>
        </div>
        <ng-container *ngIf="!(authService.isCitizen$ | async)">
          <div class="form-group">
            <label class="form-label icon-link required" for="{{ FormControlNames.Navn }}">{{
              'Kontaktoplysninger.Navn' | tekstresource
            }}</label>
            <span
              *ngIf="form.get('navn').invalid && form.get('navn').dirty"
              class="form-error-message"
              id="form-error-message-form-error"
              role="alert"
            >
              <ng-container *ngIf="form.get('navn').hasError('required')">
                {{ 'Kontaktoplysninger.Navn.IkkeValid' | tekstresource }}
              </ng-container>
            </span>
            <div class="row">
              <div class="col-7">
                <input
                  class="form-input"
                  formControlName="navn"
                  name="kontaktoplysninger-navn-input"
                  id="{{ FormControlNames.Navn }}"
                  type="text"
                  #brugerId
                />
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Bruger id -->
        <ng-container>
          <div class="form-group">
            <label class="form-label icon-link" for="input-type-text">{{
              'Kontaktoplysninger.Id' | tekstresource
            }}</label>
            <span class="form-hint" id="input-hint-message-input-type-text">
              {{ TekstResrouceKeys.Kontaktoplysninger_Id_Hint | tekstresource }}</span
            >
            <div class="bruger-id-container">
              <div class="col-7">
                <input
                  class="form-input"
                  formControlName="id"
                  name="kontaktoplysninger-id-input"
                  id="{{ FormControlNames.Id }}"
                  type="text"
                  #brugerIdField
                />
              </div>
              <button
                class="copy-icon-button"
                [bomPopover]="TekstResrouceKeys.Kontaktoplysninger_Id_Copy | tekstresource"
                [triggers]="['click', 'enter']"
                (click)="copyToClipboard(brugerIdField.value)"
              >
                <u *ngIf="linkBeforeIcon">
                  {{ linkBeforeIcon }}
                </u>
                <svg class="icon-svg">
                  <use xlink:href="#content-copy"></use>
                </svg>
                <u *ngIf="linkAfterIcon">
                  {{ linkAfterIcon }}
                </u>
              </button>
            </div>
          </div>
        </ng-container>

        <!-- Adresse input -->
        <ng-container *ngIf="authService.isCitizen$ | async">
          <div class="row pt-4">
            <bom-profil-address-input
              bomAutofocusable
              class="col-12"
              [form]="form"
              [addressString]="displayAddress"
              (addressSelected)="onAddressSelected($event)"
            ></bom-profil-address-input>
          </div>
          <div class="row pt-5" *ngIf="noAddressFound">
            <div class="col-10">
              <bom-alert
                type="warningAlert"
                descriptionKey="Kontaktoplysninger.IngenAdresseFundet"
              ></bom-alert>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!(authService.isCitizen$ | async)">
          <div class="form-group">
            <bom-profil-address-input
              bomAutofocusable
              class="col-12"
              [form]="form"
              [addressString]="displayAddress"
              (addressSelected)="onAddressSelected($event)"
            ></bom-profil-address-input>
          </div>
        </ng-container>

        <!-- kontaktform, tlf -->
        <div
          class="form-group"
          [ngClass]="{
            'form-error': form.get([FormControlNames.Telefon]).errors
          }"
        >
          <label class="form-label icon-link required" for="input-type-text">{{
            'Kontaktoplysninger.Telefon' | tekstresource
          }}</label>
          <span class="form-hint" id="input-hint-message-input-type-text">
            {{ TekstResrouceKeys.Kontaktoplysninger_Telefon_Hint | tekstresource }}</span
          >
          <span
            *ngIf="form.get([FormControlNames.Telefon]).errors"
            class="form-error-message"
            id="form-error-message-form-error"
            role="alert"
          >
            {{ form.get([FormControlNames.Telefon]).errors.message }}
          </span>

          <div class="telefon-container">
            <select
              [formControlName]="FormControlNames.Landkode"
              class="form-select landkoder"
              id="{{ FormControlNames.Landkode }}"
            >
              <option *ngFor="let landKode of landkoder" [ngValue]="landKode">
                {{ landKode.text }}
              </option>
            </select>
            <input
              bomCustomValidationMessage
              validationMsg="{{
                FormErrorKeys.Kontaktoplysninger_Telefon_IkkeValid | tekstresource
              }}"
              bomAutofocusable
              class="form-input telefon"
              [formControlName]="FormControlNames.Telefon"
              name="kontaktoplysninger-telefon-input"
              [placeholder]="'Kontaktoplysninger.Telefon' | tekstresource"
              id="{{ FormControlNames.Telefon }}"
              type="text"
            />
          </div>
        </div>

        <!-- kontaktform, email -->
        <div
          class="form-group"
          [ngClass]="{
            'form-error': form.get([FormControlNames.Email]).errors
          }"
        >
          <label class="form-label icon-link required" for="{{ FormControlNames.Email }}">{{
            'Kontaktoplysninger.Email' | tekstresource
          }}</label>
          <span class="form-hint" id="input-hint-message-input-type-text">
            {{ TekstResrouceKeys.Kontaktoplysninger_Email_Hint | tekstresource }}</span
          >
          <span
            *ngIf="form.get([FormControlNames.Email]).errors"
            class="form-error-message"
            id="form-error-message-form-error"
            role="alert"
          >
            {{ form.get([FormControlNames.Email]).errors.message }}
          </span>

          <div class="email-row">
            <div class="col-7">
              <input
                bomAutofocusable
                bomCustomValidationMessage
                [validationMsg]="'Kontaktoplysninger.Email.IkkeValid' | tekstresource"
                class="form-input"
                [formControlName]="FormControlNames.Email"
                name="kontaktoplysninger-email-input"
                [attr.placeholder]="
                  form.get(FormControlNames.NoEmailCheckbox)?.value
                    ? null
                    : ('Kontaktoplysninger.Email' | tekstresource)
                "
                [id]="FormControlNames.Email"
                type="text"
              />
            </div>

            <div class="email-checkbox">
              <input
                class="form-checkbox"
                [id]="FormControlNames.NoEmailCheckbox"
                type="checkbox"
                [formControlName]="FormControlNames.NoEmailCheckbox"
                (change)="onNoEmailCheckboxChange($event.target.checked)"
              />
              <label
                [for]="FormControlNames.NoEmailCheckbox"
                [id]="FormControlNames.KontaktMuligheder"
              >
                {{ 'Jeg har IKKE en email' }}
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>

    <button class="button button-primary" (click)="saveProfile()" [disabled]="form.invalid">
      {{ 'Gem' | tekstresource }}
    </button>
    <button
      *ngIf="!!this.projektId && !!this.sagsId"
      class="button button-secondary"
      (click)="returnToIndsend()"
    >
      {{ 'Kontaktoplysninger.TilbageTilIndsend' | tekstresource }}
    </button>
    <br />
    <br />

    <hr />
    <p [innerHtml]="'Kontaktoplysninger.GDPR' | tekstresource"></p>
  </ng-container>

  <bom-confirm-changes
    (discardChanges)="onIgnorePendingChange($event)"
    [isDiscardPendingChangesModalOpen$]="isDiscardPendingChangesModalOpen$"
    [pageName]="componentName"
  ></bom-confirm-changes>
</bom-workspace>

<ng-template #loading>
  <bom-spinner></bom-spinner>
</ng-template>
